var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLightbulb = function SvgLightbulb(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 17,
    viewBox: "0 0 11.1 14.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.446 5.502a4.923 4.923 0 1 0-8.203 3.692 2.46 2.46 0 0 1 .819 1.847v1.846a1.23 1.23 0 0 0 1.23 1.23h2.462a1.23 1.23 0 0 0 1.23-1.23v-1.89a2.46 2.46 0 0 1 .807-1.846 4.89 4.89 0 0 0 1.655-3.649M3.062 10.998h4.923"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M5.523 3.656a1.846 1.846 0 0 1 1.846 1.846"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLightbulb);
export default ForwardRef;